import { Flex, Text } from '@chakra-ui/react';

function ValuationSummary({ totalValue, outstandingShares }) {
    return (
        <Flex direction="column" width={'100%'} gap={4} mt={4} mb={4}>
            <Flex alignItems="center" justifyContent="space-between" bg="lightblue" p={2} borderRadius="md">
                <Text fontSize="lg" fontWeight="bold">Total Value of Discounted Cash Flows:</Text>
                <Text fontSize="lg" fontWeight="bold">${totalValue.toLocaleString()}</Text>
            </Flex>

            <Flex alignItems="center" justifyContent="space-between" bg="lightgreen" p={2} borderRadius="md">
                <Text fontSize="lg" fontWeight="bold">Outstanding Shares:</Text>
                <Text fontSize="lg" fontWeight="bold">{outstandingShares.toLocaleString()}</Text>
            </Flex>

            <Flex alignItems="center" justifyContent="space-between" bg="lightcoral" p={2} borderRadius="md">
                <Text fontSize="lg" fontWeight="bold">Intrinsic Value per Share:</Text>
                <Text fontSize="lg" fontWeight="bold">${(totalValue / outstandingShares).toFixed(2).toLocaleString()}</Text>
            </Flex>
        </Flex>
    );
}

export default ValuationSummary;
